import { createSelectorHook } from "react-redux";
import { StoreContext } from "../../../../app/store.js";
const useAppSelector = createSelectorHook(StoreContext);
export {
  useAppSelector
};
